export const state = {
  header: {
    requestTime: null,
    responseTime: null,
    updatedTime: null,
    userId: '',
    deviceId: 'CareRingsSystemAdmin',
    devicePhysicalId: 'CareRingsSystemAdmin',
    resultCode: 0,
    resultDetailCode: '',
    errorCode: '',
    message: '',
    messageDetail: ''
  },
  authorization: '',
  loginFlag: false,
  unauthorizedFlag: false
}
export const mutations = {
  setLoginUser(state, payload) {
    state.header.userId = payload.userId
  },
  successLoginFlag(state, response) {
    sessionStorage.setItem(
      'masterUser',
      JSON.stringify({
        userId: state.header.userId,
        authorization: 'Bearer' + ' ' + response.headers.authorization,
        loginFlag: true
      })
    )
    state.authorization = 'Bearer' + ' ' + response.headers.authorization
    state.loginFlag = true
  },
  successLogoutFlag(state) {
    sessionStorage.removeItem('masterUser')
    state.authorization = ''
    state.header.tenantKey = ''
    state.loginFlag = false
  },
  clearCompanyInfo(state) {
    state.header.companyId = ''
    state.header.tenantKey = ''
  },
  setCompanyInfo(state, payload) {
    state.header.companyId = payload.companyId
    state.header.tenantKey = payload.tenantKey
  },
  changeUnauthorizedFlag(state) {
    state.unauthorizedFlag = !state.unauthorizedFlag
  },
  restoreSession(state) {
    const masterUserData = sessionStorage.getItem('masterUser')
    if (masterUserData) {
      const masterUserInfo = JSON.parse(masterUserData)
      state.authorization = masterUserInfo.authorization
      state.loginFlag = masterUserInfo.loginFlag
      state.header.userId = masterUserInfo.userId
    }
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/systemAdminDefineModules/systemAdminDefineMutation.js